import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, set, useForm } from "react-hook-form";
import Select from "react-select";
import {
    country,
    CURRENCY,
    CURRENCY_NAME,
    CUSTOM_SELECT_STYLES,
    CUSTOM_SELECT_STYLES_AREA_CODE,
    GOLD_QUANTITY_LIST,
    I_POP_OVER,
    PRODUCT_GOLD_TYPE,
    SELECT_BOX_THEME,
    SUBSCRIPTION_MODULE_TYPE,
    SUPPORTED_PAYMENT_METHOD,
    terms,
} from "../../constants";
import { useLocation, useNavigate } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from "../../components/currencyFormat/currencyFormat";
import Currency from "../../components/currency";
import {
    saveManualDetails,
    createStripeTokenAction,
    extraFeeCalcAction,
    setBankTranferBackTrigger,
    currencyConversionCalcHighAction,
    setCurrencyWatch,
    setTripleaUrl,
    selectedCardFunc,
    setPaymentSteps,
    setQuantity,
    createManualEntryAction,
    setOpenCartPage,
    subscriptionPlan,
    getIsPlanValidAction,
    createDptOrderAction,
    createPayNowOrderAction,
    getDptOrderStatusAction,
    getPayNowOrderStatusAction,
} from "../../actions/stripe";
import InfoModalStatic from "../dashboard/infoModalStatic";
import SelectPayment from "../../components/buyProduct/SelectPayment";
import PayWithCard from "../../components/buyProduct/PayWithCard";
import PaymentStatus from "../../components/buyProduct/PaymentStatus";
import BankDetail from "./BankDetail";
import PaymentSteps from "./PaymentSteps";
import { setFailedMessage } from "../../actions/message";
import GetToaster from "../../components/header/getToaster";
import { addPublicUserPaymentAction, logoutInvalidToken } from "../../actions/auth";
import { isDesktop, isMobile } from "react-device-detect";
import { getSingleSubscriptonPlan, setTemporaryCompany } from "../../actions/subscriptionPlan";
import PlanInvalid from "./PlanInvalid";
import PayoutDetail from "./PayoutDetail";
import { getProfileAction } from "../../actions/user";
import SubHeader from "../../components/SubHeader";
import PayoutDetailComponent from "./PayoutDetailComponent";
import StepHeader from "./StepHeader";
import PublicPageHeader from "../../components/PublicPageHeader";
import PublicPageFooter from "../../components/PublicPageFooter";
import { SET_QUOTATION_DETAIL } from "../../actions/types";
import { addCompany, editCompany } from "../../actions/company";
import {
    addCampaignAction,
    addCampaignAiAction,
    getSingleCampaignDetailAction,
} from "../../actions/peopleai";

const HOSTED_PAYMENT_METHODS = [
    SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO,
    SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW,
];

const HostedPaymentRedirect = ({ url, onBack }) => {
    useEffect(() => {
        if (!url) return undefined;

        const timer = setTimeout(() => {
            try {
                const targetWindow = window.top && window.top !== window ? window.top : window;
                targetWindow.location.assign(url);
            } catch (error) {
                window.location.assign(url);
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [url]);

    return (
        <div className="hostedPaymentLoading">
            <div className="hostedPaymentLoadingText">
                <i className="animateSpin fa-solid fa-circle-notch"></i>
                <span>Redirecting to secure checkout</span>
            </div>
            <div className="hostedPaymentActions">
                <button type="button" className="gobackButton" onClick={onBack}>
                    <p className="m-0">Back</p>
                </button>
                <a className="gobackButton continueButton" href={url} target="_top" rel="noreferrer">
                    <p className="m-0">Continue to payment</p>
                </a>
            </div>
        </div>
    );
};

export function BankTransferPublicFlow({
    embedded = false,
    embeddedPlanId,
    embeddedCompanyId,
    embeddedQuotationDetail,
    onEmbeddedBack,
    onEmbeddedStepChange,
} = {}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const {
        control,
        register,
        getValues,
        watch,
        setValue,
        trigger,
        formState: { errors },
        setError,
        clearErrors
    } = useForm({
        mode: "onTouched",
    });

    const [loader, setLoader] = useState(false);
    const [isTransactionVisible, setTransactionVisible] = useState(true);
    const [infoModalStaicShow, setInfoModalStaticShow] = useState(false);
    const [infoModalStaicShowType, setInfoModalStaticShowType] = useState(null);
    const [addCardLoader, setAddCardLoader] = useState(false)
    const [addUserDetailLoader, setAddUserDetailLoader] = useState(false)
    const [hostedPaymentUrl, setHostedPaymentUrl] = useState(null);
    const [autoStartHostedPayment, setAutoStartHostedPayment] = useState(false);
    const [hostedPaymentId, setHostedPaymentId] = useState(null);
    const { toastMessage } = useSelector((state) => state.message);
    const {
        stripePlans,
        paymentMethodSelection,
        stripeType,
        savedbankInfoDetails,
        isOverrideProduct,
        stripeSubscription,
        cartAmount,
        forceCartAmount,
        triggerBankTransferBack,
        selectedQuantity,
        isManualPayment,
        isManualPaymentType,
        selectedStep,
        selectedCard,
        isTripleaUrl,
        temporaryCompany,
        paymentLinkState,
        quotationDetail
    } = useSelector((state) => state.stripe);
    const isloadingRef = useRef(false)
    const { isLoggedIn } = useSelector(state => state?.auth);
    const { user } = useSelector(state => state?.user);
    const { bankDetail } = useSelector((state) => state.settings);
    const {
        addCompanyTrigger,
        activateAddedCompany,
        selectedCompany,
        advisorCompany,
        pendingCompanySelected,
        companyType,
        company,
        recommendedPlanPricing,
    } = useSelector(state => state.company || {});
    const { profileIds, singleCampaignDetail, campaignDetailToSend } = useSelector(state => state.peopleai || {});
    const pathnames = location?.pathname?.split("/").filter((x) => x);
    const planId = embeddedPlanId || pathnames?.[pathnames.length - 1];
    const embeddedInitializedRef = useRef(false);
    const activatedPaymentIdsRef = useRef(new Set());
    const generatedCampaignPaymentIdsRef = useRef(new Set());
    const hostedOrderNoRef = useRef(null);
    const hostedPaymentIdRef = useRef(null);
    const hostedPaymentPollIntervalRef = useRef(null);
    const hostedPaymentStatusCheckingRef = useRef(false);
    const hostedPaymentResolvedRef = useRef(false);
    const currencyWatch = watch("currency");
    const saveInfoWatch = watch("saveInfo");
    const amountWatch = watch("amount");
    const cryptoAmountWatch = watch("cryptoAmount");
    const isHostedPaymentMethod = HOSTED_PAYMENT_METHODS.includes(paymentMethodSelection);
    const defaultTransferCurrency = useMemo(() => CURRENCY_NAME.find(item => item.value === "usd") || CURRENCY_NAME[0], []);
    const cryptoTransferCurrency = defaultTransferCurrency;
    const payNowCurrency = useMemo(() => CURRENCY_NAME.find(item => item.value === "sgd") || { value: "sgd", label: "SGD" }, []);
    const bankTransferCurrencies = useMemo(() => CURRENCY_NAME.filter(item =>
        ["usd", "sgd"].includes(item?.value)
    ), []);
    const isActivationPaymentFlow = embedded && Boolean(embeddedPlanId || embeddedCompanyId);
    const isCompanySetupFlow = isActivationPaymentFlow || ((addCompanyTrigger || activateAddedCompany) && companyType === 1);
    const requestedPaymentStep = parseInt(new URLSearchParams(location.search).get("paymentStep"), 10);
    const embeddedInitialPaymentStep =
        embedded && !Number.isNaN(requestedPaymentStep) && requestedPaymentStep >= 1 && requestedPaymentStep <= 5
            ? requestedPaymentStep
            : null;
    const isBusinessPlanType =
        parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN ||
        parseInt(stripePlans?.planType?.value) === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN ||
        (
            parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.CUSTOM &&
            (stripePlans?.activationplan === true || stripePlans?.activationPlan === true)
        ) ||
        (
            parseInt(stripePlans?.planType?.value) === SUBSCRIPTION_MODULE_TYPE.CUSTOM &&
            (stripePlans?.activationplan === true || stripePlans?.activationPlan === true)
        );
    const BUSINESS_PLAN_DISPLAY_MODE = {
        FEASIBILITY: "FEASIBILITY",
        FIXED: "FIXED",
        QUOTATION: "QUOTATION",
    };
    const BUSINESS_PLAN_PRICE_MAP = {
        WEALTH_RETENTION_UNLICENSED: { feasibility: 1425, activation: 9500 },
        TRADE_EFFICIENCY_UNLICENSED: { feasibility: 375, activation: 2500 },
        TRADE_EFFICIENCY_LICENSED: { feasibility: 975, activation: 6500 },
        CAPITAL_ACCESS_UNLICENSED: { feasibility: 750, activation: 5000 },
        DIGITAL_ASSETS_UNLICENSED: { feasibility: 825, activation: 5500 },
        WEALTH_RETENTION_LICENSED_SFO: { fixed: 37000 },
        WEALTH_RETENTION_LICENSED_MFO: { quoteFrom: 65000 },
        CAPITAL_ACCESS_LICENSED: { quoteFrom: 58000 },
        DIGITAL_ASSETS_LICENSED: { quoteFrom: 68000 },
    };
    const normalizeBusinessPlanText = value =>
        String(value || "")
            .toLowerCase()
            .replace(/[–—]/g, "-")
            .replace(/\s+/g, " ")
            .trim();
    const getBusinessPlanText = plan =>
        normalizeBusinessPlanText([
            plan?.name,
            plan?.title,
            plan?.fullName,
            plan?.businessPlanPayload?.plan?.fullName,
            plan?.businessPlanPayload?.plan?.name,
            plan?.businessPlanOptionCode,
            plan?.businessPlanOption,
        ].filter(Boolean).join(" "));
    const getBusinessPlanCode = plan =>
        plan?.businessPlanCode ?? plan?.businessPlanPayload?.plan?.code ?? plan?.planCode ?? null;
    const getBusinessPlanPriceKey = plan => {
        const code = getBusinessPlanCode(plan);
        const text = getBusinessPlanText(plan);

        if (code === "WEALTH_RETENTION_LICENSED") {
            return text.includes("mfo") ? "WEALTH_RETENTION_LICENSED_MFO" : "WEALTH_RETENTION_LICENSED_SFO";
        }

        return code;
    };
    const getBusinessPlanDisplayMode = plan => {
        const priceKey = getBusinessPlanPriceKey(plan);
        const text = getBusinessPlanText(plan);

        if (["WEALTH_RETENTION_LICENSED_MFO", "CAPITAL_ACCESS_LICENSED", "DIGITAL_ASSETS_LICENSED"].includes(priceKey)) {
            return BUSINESS_PLAN_DISPLAY_MODE.QUOTATION;
        }

        if (priceKey === "WEALTH_RETENTION_LICENSED_SFO") {
            return text.includes("fixed") || plan?.businessPlanOption === "planB"
                ? BUSINESS_PLAN_DISPLAY_MODE.FIXED
                : BUSINESS_PLAN_DISPLAY_MODE.QUOTATION;
        }

        return BUSINESS_PLAN_DISPLAY_MODE.FEASIBILITY;
    };
    const getFirstAmount = (...values) =>
        values.find(value => value !== undefined && value !== null && value !== "");
    const isFixedAnnualPlan = plan =>
        /PLAN_B_FIXED_ANNUAL|fixed annual/i.test([
            plan?.code,
            plan?.slug,
            plan?.name,
            plan?.fullName,
            plan?.pricingOptionName,
        ].filter(Boolean).join(" "));
    const businessPlanDisplayMode = getBusinessPlanDisplayMode(stripePlans);
    const businessPlanOption = stripePlans?.businessPlanOption;
    const businessPlanActivationPrice = Number(
        stripePlans?.activationYearTotal ??
        (businessPlanOption ? stripePlans?.businessPlanPayload?.[businessPlanOption]?.activationYearTotal : null) ??
        stripePlans?.businessPlanPayload?.planA?.activationYearTotal ??
        stripePlans?.businessPlanPayload?.planB?.activationYearTotal ??
        stripePlans?.price ??
        stripePlans?.amount ??
        0
    );
    const businessPlanPlanPrice = Number(
        stripePlans?.price ??
        stripePlans?.amount ??
        stripePlans?.payableAmount ??
        stripePlans?.basePrice ??
        0
    );
    const businessPlanPriceConfig = {
        ...(BUSINESS_PLAN_PRICE_MAP[getBusinessPlanPriceKey(stripePlans)] || {}),
        activation: businessPlanActivationPrice,
        feasibility: businessPlanPlanPrice,
    };
    const businessPlanDueNow =
        businessPlanDisplayMode === BUSINESS_PLAN_DISPLAY_MODE.FIXED
            ? businessPlanPriceConfig.fixed || 0
            : businessPlanDisplayMode === BUSINESS_PLAN_DISPLAY_MODE.FEASIBILITY
                ? businessPlanPriceConfig.feasibility || 0
                : 0;
    const businessPlanCurrency =
        stripePlans?.currency?.value ||
        stripePlans?.currency ||
        recommendedPlanPricing?.currency?.toLowerCase?.() ||
        getValues("currency")?.value;
    const selectedBusinessPricingPlan = isFixedAnnualPlan(stripePlans)
        ? recommendedPlanPricing?.planB
        : recommendedPlanPricing?.planA;
    const businessPlanFixedFee =
        getFirstAmount(
            stripePlans?.annualFixedFee,
            stripePlans?.annualFee,
            stripePlans?.fixedFee,
            stripePlans?.planA?.annualFixedFee,
            stripePlans?.planB?.annualFee,
            selectedBusinessPricingPlan?.annualFixedFee,
            selectedBusinessPricingPlan?.annualFee,
            stripePlans?.activationYearFixedComponent,
            stripePlans?.planA?.activationYearFixedComponent,
            selectedBusinessPricingPlan?.activationYearFixedComponent,
        ) || 0;
    const businessPlanPlatformFee =
        getFirstAmount(
            stripePlans?.usageFee,
            stripePlans?.platformFee,
            stripePlans?.businessPlanPayload?.[stripePlans?.businessPlanOption]?.usageFee,
            stripePlans?.businessPlanPayload?.planA?.usageFee,
            stripePlans?.planA?.usageFee,
            selectedBusinessPricingPlan?.usageFee,
            recommendedPlanPricing?.planA?.usageFee,
        ) || 0;
    const hasBusinessPlanPlatformFee = Number(businessPlanPlatformFee || 0) > 0;
    const shouldShowIncludedTransactionFee =
        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ||
        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW ||
        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER;
    const getBusinessPlanCheckoutAmount = (data = {}) => {
        const forcedPayableAmount = parseFloat(forceCartAmount?.payableAmount);
        if (forcedPayableAmount > 0) return forcedPayableAmount;

        const transactionFee = shouldShowIncludedTransactionFee
            ? 0
            : parseFloat(
                data?.transactionFee ??
                getValues("transactionFee") ??
                forceCartAmount?.transactionFees ??
                0
            ) || 0;

        return (parseFloat(businessPlanDueNow) || 0) + transactionFee;
    };
    const getBusinessPlanCheckoutCurrency = () =>
        getValues("currency")?.value || businessPlanCurrency || "sgd";

    const bankTransferDetail =
        (bankDetail &&
            currencyWatch?.value &&
            bankDetail.find((x) => x.id.toLowerCase() === currencyWatch?.value)) ||
        {};

    useEffect(() => {
        const getPlanValidDetail = async () => {
            dispatch(getProfileAction())
            if (embedded && embeddedQuotationDetail) {
                if (embeddedInitializedRef.current) return
                embeddedInitializedRef.current = true
                dispatch({ type: SET_QUOTATION_DETAIL, payload: embeddedQuotationDetail });
                dispatch(setPaymentSteps(embeddedInitialPaymentStep || 1));
                return
            }
            if (!planId) {
                dispatch(setPaymentSteps(1))
                return
            }
            var resp = await dispatch(getIsPlanValidAction(planId))
            if (resp?.data === 'Expired' || !resp?.status) {
                dispatch(setPaymentSteps(0))
            } else {
                dispatch(setPaymentSteps(1))
            }
        }
        getPlanValidDetail()
    }, [dispatch, embedded, embeddedInitialPaymentStep, embeddedQuotationDetail, planId])

    useEffect(() => {
        if (embedded && typeof onEmbeddedStepChange === "function") {
            onEmbeddedStepChange(selectedStep);
        }
        if (!isloadingRef?.current) {
            if (isLoggedIn) {
                // dispatch(logoutInvalidToken())
                isloadingRef.current = true
            }
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [embedded, isLoggedIn, onEmbeddedStepChange, selectedStep]);

    useEffect(() => {
        setValue('firstName', user?.first_name)
        setValue('lastName', user?.last_name)
        setValue('email', user?.email)
        setValue(
            'areaCode',
            user.areaCode
                ? country.filter(x => x.dial_code === user.areaCode)[0]
                : '',
        );
        setValue('phone', user.phone && user.phone);
    }, [setValue, user])


    // register hidden fields used by totals/fees
    useEffect(() => {
        register("baseAmountRate", { required: true });
        register("transactionFee", { required: false });
        register("amount", { required: true });
        register("cryptoAmount", { required: false });
    }, [register]);

    // ensure we have a default quantity of 1 since we removed the quantity step
    useEffect(() => {
        if (!selectedQuantity?.value) {
            dispatch(setQuantity(GOLD_QUANTITY_LIST[0])); // first option (usually value=1)
        }
    }, [dispatch, selectedQuantity]);

    const calcExtraFeeCharges = () => {
        const calculationPrice =
            isBusinessPlanType && businessPlanDueNow
                ? businessPlanDueNow
                : stripePlans?.price;
        const payload = {
            price: calculationPrice,
            quantity: selectedQuantity?.value || 1,
            paymentMethodSelection: parseInt(paymentMethodSelection),
            goldType: stripePlans?.goldProductType?.value,
        };
        dispatch(
            extraFeeCalcAction(
                payload?.paymentMethodSelection,
                parseInt(stripeType),
                payload
            )
        );
    };

    // existing initialization + safety redirects
    useEffect(() => {
        const checkIfSubscriptionDetailsAvailable = () => {
            // if (selectedStep !== 1 && stripePlans && Object.keys(stripePlans).length === 0) {
            //     navigate(RoutesPaths.HOME)
            // } else {
            if (!triggerBankTransferBack) {
                if (stripePlans?.price || (isBusinessPlanType && businessPlanDueNow)) {
                    calcExtraFeeCharges();
                }
            }
            // }
        };
        checkIfSubscriptionDetailsAvailable();
    }, [stripePlans, dispatch, selectedStep]);

    const calculateCartForceAction = (fromForce = null) => {
        const calculationPrice =
            isBusinessPlanType && businessPlanDueNow
                ? businessPlanDueNow
                : parseFloat(isManualPayment) > 0
                    ? isManualPayment
                    : isManualPaymentType
                        ? isManualPayment
                        : stripePlans?.price;
        const payload = {
            baseReqCurrency: stripePlans?.currency?.value,
            from: fromForce ? fromForce : stripePlans?.currency?.value,
            to: currencyWatch?.value,
            price: calculationPrice,
            paymentMethodSelection: parseInt(paymentMethodSelection),
            moduleType: parseInt(stripeType),
            quantity: selectedQuantity?.value || 1,
            isManual: parseFloat(isManualPayment) > 0 ? true : false,
            goldType: stripePlans?.goldProductType?.value,
        };
        if (isBusinessPlanType && businessPlanDueNow) {
            setValue("cryptoAmount", businessPlanDueNow);
        } else if (parseFloat(isManualPayment) > 0) {
            setValue("cryptoAmount", isManualPayment);
        } else {
            setValue("cryptoAmount", stripePlans?.price);
        }
        dispatch(currencyConversionCalcHighAction(payload));
    };

    useEffect(() => {
        calculateCartForceAction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartAmount, isManualPayment]);

    useEffect(() => {
        if (
            stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.KILOGRAM &&
            [CURRENCY.INR, CURRENCY.CNY].includes(currencyWatch?.value)
        ) {
            dispatch(setQuantity(GOLD_QUANTITY_LIST[0]));
        }
        calculateCartForceAction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currencyWatch]);

    useEffect(() => {
        dispatch(setBankTranferBackTrigger(false));
        if (!triggerBankTransferBack) {
            calcExtraFeeCharges();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedQuantity, triggerBankTransferBack]);

    // keep saved sender info (bank step) behavior
    useEffect(() => {
        if (savedbankInfoDetails && Object.keys(savedbankInfoDetails).length > 0) {
            const savedCurrency = savedbankInfoDetails?.currency;
            const nextCurrency =
                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW
                    ? payNowCurrency
                    : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                        ? cryptoTransferCurrency
                        : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER &&
                            !["usd", "sgd"].includes(savedCurrency?.value)
                            ? defaultTransferCurrency
                            : savedCurrency;
            setValue("currency", nextCurrency);
            setValue("sendingInstruction", savedbankInfoDetails?.sendingInstruction);
            setValue("number", savedbankInfoDetails.number);
            setValue("nickName", savedbankInfoDetails.nickName);
        }
    }, [setValue, savedbankInfoDetails, paymentMethodSelection, payNowCurrency, cryptoTransferCurrency, defaultTransferCurrency]);

    useEffect(() => {
        if (paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW && currencyWatch?.value !== payNowCurrency.value) {
            setValue("currency", payNowCurrency);
        } else if (paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO && currencyWatch?.value !== cryptoTransferCurrency.value) {
            setValue("currency", cryptoTransferCurrency);
        } else if (
            paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER &&
            currencyWatch?.value &&
            !["usd", "sgd"].includes(currencyWatch.value)
        ) {
            setValue("currency", defaultTransferCurrency);
        }
    }, [currencyWatch?.value, paymentMethodSelection, setValue, payNowCurrency, cryptoTransferCurrency, defaultTransferCurrency]);

    useEffect(() => {
        if (isBusinessPlanType && businessPlanDisplayMode !== BUSINESS_PLAN_DISPLAY_MODE.QUOTATION && businessPlanDueNow) {
            const businessPlanCheckoutAmount = getBusinessPlanCheckoutAmount();

            setValue("baseAmountRate", forceCartAmount?.baseAmountRate || businessPlanDueNow);
            setValue("transactionFee", forceCartAmount?.transactionFees || 0);
            setValue("amount", businessPlanCheckoutAmount || businessPlanDueNow);
            setValue("cryptoAmount", businessPlanDueNow);
            trigger("amount");
            return;
        }

        setValue("baseAmountRate", forceCartAmount?.baseAmountRate);
        setValue("transactionFee", forceCartAmount?.transactionFees);
        setValue("amount", forceCartAmount?.payableAmount);
        if (
            paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO &&
            (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PLAN ||
                parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PRODUCT ||
                parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB)
        ) {
            setValue("cryptoAmount", stripePlans?.price);
        }
    }, [businessPlanDisplayMode, businessPlanDueNow, forceCartAmount, isBusinessPlanType, paymentMethodSelection, setValue, stripePlans, stripeType, trigger]);

    // validation rules for account/token number (unchanged)
    let validationRules = {
        required: {
            value: true,
            message:
                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                    ? "Enter your account number"
                    : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                        ? "Enter your wallet address"
                        : "",
        },
    };

    if (
        [
            SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER,
            SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO,
            SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW,
        ].includes(paymentMethodSelection)
    ) {
        validationRules.pattern = {
            value: /^[a-zA-Z0-9]+$/,
            message: "Please enter only alphanumeric value",
        };
    }

    const getActivationCompanyId = () => {
        return pendingCompanySelected?.id ||
            pendingCompanySelected?._id ||
            embeddedCompanyId ||
            selectedCompany?.id ||
            selectedCompany?._id ||
            company?.id ||
            company?._id ||
            temporaryCompany;
    };

    const getAddCompanyPaymentCompany = () => {
        if (isActivationPaymentFlow) {
            return pendingCompanySelected || { id: embeddedCompanyId };
        }

        if (activateAddedCompany) {
            return selectedCompany || company;
        }

        if (isCompanySetupFlow) {
            return pendingCompanySelected || selectedCompany || company || advisorCompany;
        }

        return selectedCompany || company;
    };

    const getPaymentIdFromResponse = paymentResp =>
        typeof paymentResp === "string" || typeof paymentResp === "number"
            ? paymentResp
            : paymentResp?.payment?.id ||
            paymentResp?.payment?._id ||
            paymentResp?.payment?.paymentId ||
            paymentResp?.data?.paymentId ||
            paymentResp?.data?.id ||
            paymentResp?.data?._id ||
            paymentResp?.id ||
            paymentResp?._id ||
            paymentResp?.paymentId ||
            null;

    const getCheckoutAmount = data => {
        const amount = data?.amount ?? getValues("amount") ?? amountWatch;
        if (isBusinessPlanType && businessPlanDueNow) {
            return parseFloat(getBusinessPlanCheckoutAmount(data) || amount || 0);
        }

        const fallbackAmount =
            forceCartAmount?.payableAmount ??
            businessPlanDueNow ??
            (parseFloat(isManualPayment) > 0 ? isManualPayment : null) ??
            stripePlans?.price;

        return parseFloat(amount || fallbackAmount || 0);
    };

    const getCheckoutBaseAmountRate = data => {
        const baseAmountRate = data?.baseAmountRate ?? getValues("baseAmountRate");
        const fallbackAmount =
            forceCartAmount?.baseAmountRate ??
            businessPlanDueNow ??
            (parseFloat(isManualPayment) > 0 ? isManualPayment : null) ??
            stripePlans?.price;

        return parseFloat(baseAmountRate || fallbackAmount || 0);
    };

    const getCheckoutTransactionFee = data =>
        parseFloat(data?.transactionFee ?? getValues("transactionFee") ?? forceCartAmount?.transactionFees ?? 0) || 0;

    const getHostedPaymentUrlFromResponse = resp =>
        resp?.data?.hosted_url ||
        resp?.data?.url ||
        resp?.hosted_url ||
        resp?.url ||
        null;

    const getHostedOrderNoFromResponse = resp =>
        resp?.data?.orderId ||
        resp?.data?.id ||
        resp?.orderId ||
        resp?.id ||
        null;

    const getHostedPaymentIdFromResponse = resp =>
        resp?.payment?.id ||
        resp?.payment?._id ||
        resp?.data?.paymentId ||
        resp?.payment?.paymentId ||
        null;

    const stopHostedPaymentStatusPolling = () => {
        if (hostedPaymentPollIntervalRef.current) {
            clearInterval(hostedPaymentPollIntervalRef.current);
            hostedPaymentPollIntervalRef.current = null;
        }
    };

    const getHostedPaymentTerminalStatus = resp => {
        const paymentStatus = String(resp?.payment?.payment_status || "").toLowerCase();
        const paymentState = String(resp?.payment?.status || "").toLowerCase();
        const orderStatus = String(resp?.data?.status || resp?.statusText || "").toLowerCase();
        const successStatuses = ["paid", "complete", "completed", "success", "succeeded"];
        const failedStatuses = ["failed", "fail", "cancel", "canceled", "cancelled", "expired"];

        if (
            successStatuses.includes(paymentStatus) ||
            successStatuses.includes(paymentState) ||
            successStatuses.includes(orderStatus)
        ) {
            return "success";
        }

        if (
            failedStatuses.includes(paymentStatus) ||
            failedStatuses.includes(paymentState) ||
            failedStatuses.includes(orderStatus)
        ) {
            return "failed";
        }

        return null;
    };

    const handleHostedPaymentRedirect = async (url, baseUrl) => {
        hostedPaymentResolvedRef.current = true;
        stopHostedPaymentStatusPolling();
        const normalizedBase = String(baseUrl || url || "").replace(/\/$/, "");
        const isSuccess = /\/payment\/success$/.test(normalizedBase) || /\/callback$/.test(normalizedBase);
        const isCancel = /\/payment\/cancel$/.test(normalizedBase);

        if (isSuccess) {
            await activateCompanyAfterPayment(hostedPaymentIdRef.current || hostedPaymentId);
            setHostedPaymentUrl(null);
            dispatch(setTripleaUrl(null, false));
            dispatch(setPaymentSteps(5));
            return;
        }

        if (isCancel) {
            setHostedPaymentUrl(null);
            dispatch(setTripleaUrl(null, false));
            dispatch(setFailedMessage("Payment was cancelled."));
        }
    };

    const checkHostedPaymentOrderStatus = async () => {
        const orderNo = hostedOrderNoRef.current;
        if (!orderNo || hostedPaymentStatusCheckingRef.current || hostedPaymentResolvedRef.current) {
            return;
        }

        hostedPaymentStatusCheckingRef.current = true;
        try {
            const resp = await dispatch(
                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                    ? getDptOrderStatusAction(orderNo)
                    : getPayNowOrderStatusAction(orderNo)
            );
            const paymentId = getHostedPaymentIdFromResponse(resp);
            if (paymentId) {
                setHostedPaymentId(paymentId);
                hostedPaymentIdRef.current = paymentId;
            }

            const terminalStatus = getHostedPaymentTerminalStatus(resp);
            if (!terminalStatus) return;

            const fallbackRedirectPath = terminalStatus === "success" ? "/payment/success" : "/payment/cancel";
            const redirectUrl = terminalStatus === "success"
                ? resp?.data?.returnUrl || `${fallbackRedirectPath}?orderNo=${encodeURIComponent(orderNo)}`
                : resp?.data?.backUrl || resp?.data?.cancelUrl || `${fallbackRedirectPath}?orderNo=${encodeURIComponent(orderNo)}`;
            const redirectBaseUrl = redirectUrl.split("?")[0] || fallbackRedirectPath;
            await handleHostedPaymentRedirect(redirectUrl, redirectBaseUrl);
        } catch (error) {
            console.log("Payment status polling error:", error?.message || error);
        } finally {
            hostedPaymentStatusCheckingRef.current = false;
        }
    };

    const startHostedPaymentStatusPolling = resp => {
        const orderNo = getHostedOrderNoFromResponse(resp);
        if (!orderNo) return;

        stopHostedPaymentStatusPolling();
        hostedOrderNoRef.current = orderNo;
        hostedPaymentResolvedRef.current = false;
        hostedPaymentPollIntervalRef.current = setInterval(checkHostedPaymentOrderStatus, 5000);
    };

    const preserveActivationSelectPaymentStep = () => {
        if (!embedded || !isCompanySetupFlow) return;

        const nextSearchParams = new URLSearchParams(location.search);
        const companyId = getActivationCompanyId();

        nextSearchParams.set("step", "6");
        nextSearchParams.set("paymentStep", "3");
        if (companyId) nextSearchParams.set("id", companyId);

        const nextSearch = nextSearchParams.toString();
        navigate(`${location.pathname}${nextSearch ? `?${nextSearch}` : ""}${location.hash}`, { replace: true });
    };

    useEffect(() => {
        return () => stopHostedPaymentStatusPolling();
    }, []);

    const getCampaignProfilesForPayload = campaign => {
        const raw = profileIds ?? [];
        const ids = (Array.isArray(raw) ? raw : [raw])
            .flatMap(value => String(value).split(","))
            .map(value => value.trim())
            .filter(Boolean);
        const campaignProfiles = campaign?.profiles ?? [];
        const metaById = new Map(
            campaignProfiles.map(profile => {
                const id = String(profile?.id ?? profile?.profile ?? profile?._id ?? "");
                return [id, {
                    selected: profile?.selected === false ? false : true,
                    verified: !!profile?.verified,
                }];
            })
        );

        return ids.map(id => {
            const meta = metaById.get(id);
            return {
                profile: id,
                selected: meta ? meta.selected : true,
                verified: meta ? meta.verified : false,
            };
        });
    };

    const createCampaignAfterAddCompanyPayment = async (companyId, paymentId) => {
        if (!isCompanySetupFlow || !companyId || !paymentId || generatedCampaignPaymentIdsRef.current.has(paymentId)) {
            return null;
        }

        const campaign = singleCampaignDetail?.campaign || campaignDetailToSend?.campaign || campaignDetailToSend;
        const hasCampaignInfo = !!(
            campaign &&
            (campaign?.name || campaign?.description || campaign?.targetting || campaign?.seniority || campaign?.location || campaign?.industry)
        );

        if (!hasCampaignInfo) {
            return null;
        }

        generatedCampaignPaymentIdsRef.current.add(paymentId);

        try {
            const campaignPayload = {
                company: companyId,
                seniority: campaign?.seniority,
                location: campaign?.location,
                industry: campaign?.industry,
                targetting: campaign?.targetting,
                onlyVerifiedUsers: campaign?.isverified || campaign?.onlyVerifiedUsers || false,
                profiles: getCampaignProfilesForPayload(campaign),
                name: campaign?.name || "",
                description: campaign?.description || "",
                tags: campaign?.tags || "",
                images: campaign?.images || [],
            };
            const campaignResp = await dispatch(addCampaignAction(campaignPayload));

            if (campaignResp?.status && campaignResp?.data) {
                await dispatch(getSingleCampaignDetailAction(campaignResp.data));
                dispatch(addCampaignAiAction(null));
            }

            return campaignResp;
        } catch (error) {
            console.log("Failed to create campaign after add company payment", error?.message || error);
            return null;
        }
    };

    const activateCompanyAfterPayment = async paymentResp => {
        if (!isCompanySetupFlow) {
            return null;
        }

        const paymentId = getPaymentIdFromResponse(paymentResp);
        const paymentCompany = getAddCompanyPaymentCompany();
        const companyId = paymentCompany?.id || paymentCompany?._id || getActivationCompanyId();

        if (!companyId || !paymentId || activatedPaymentIdsRef.current.has(paymentId)) {
            return null;
        }

        activatedPaymentIdsRef.current.add(paymentId);

        if (activateAddedCompany) {
            return dispatch(editCompany(companyId, {
                paymentId,
                isActive: true,
            }));
        }

        const payload = {
            id: companyId,
            paymentId,
            isActive: true,
            isAdminApproved: false,
        };
        const resp = await dispatch(addCompany(payload, false));

        if (resp?.status) {
            await createCampaignAfterAddCompanyPayment(companyId, paymentId);
        }

        return resp;
    };

    // Proceed handlers (unchanged)
    const handleProceedCard = async () => {
        const checkoutAmount = getCheckoutAmount(getValues());

        if (checkoutAmount && stripeSubscription) {
            let payload = {
                companyId: getActivationCompanyId(),
                planId:
                    parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
                        ? stripeSubscription._id
                        : stripeSubscription.id,
                subscriptionModuleType: parseInt(stripeType),
                paymentMethodSelection: paymentMethodSelection,
                quantity: selectedQuantity || GOLD_QUANTITY_LIST[0],
                currency: getValues("currency"),
                baseAmountRate: parseFloat(forceCartAmount?.baseAmountRate),
                baseRequestCurrency: stripeSubscription?.currency?.value || null,
                transactionFee: parseFloat(forceCartAmount?.transactionFees),
                amount: checkoutAmount,
                cardId: selectedCard?.id,
            };
            if (payload.subscriptionModuleType === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL) {
                payload.baseRequestShareType = stripeSubscription?.capital?.shareType;
                payload.capital = stripeSubscription?.capital?.id;
                payload.loadStripeData = {
                    currency: stripeSubscription?.currency?.value,
                    amount: checkoutAmount,
                };
            }
            if (payload.planId || Object.keys(payload.loadStripeData || {}).length > 0) {
                const resp = await dispatch(createStripeTokenAction(payload, true));
                const paymentId = getPaymentIdFromResponse(resp);
                if (paymentId) {
                    setHostedPaymentId(paymentId);
                    hostedPaymentIdRef.current = paymentId;
                }
                await activateCompanyAfterPayment(resp);
                setLoader(false);
                // localStorage.removeItem("chatId");
            } else {
                setLoader(false);
            }
        } else {
            dispatch(
                setFailedMessage("Could not able to proceed, please contact administrator.")
            );
            setLoader(false);
        }
    };

    const handleProceedCrypto = async (payloadData = {}) => {
        const checkoutAmount = getCheckoutAmount(payloadData);
        if (checkoutAmount > 0 && stripeType) {
            let payload = {
                company: getActivationCompanyId(),
                planId:
                    (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
                        ? stripePlans?._id
                        : stripePlans?.id) || null,
                subscriptionModuleType: parseInt(stripeType),
                paymentMethodSelection: paymentMethodSelection,
                quantity: selectedQuantity || GOLD_QUANTITY_LIST[0],
                currency: payloadData?.currency || getValues("currency"),
                baseAmountRate: getCheckoutBaseAmountRate(payloadData),
                baseRequestCurrency: stripePlans?.currency?.value || null,
                amount: checkoutAmount,
                transactionFee: getCheckoutTransactionFee(payloadData),
            };
            if (payload.subscriptionModuleType === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL) {
                payload.baseRequestShareType = stripePlans?.capital?.shareType;
                payload.capital = stripePlans?.capital?.id;
            }
            const dptPayload = {
                ...payload,
                companyId: payload.company,
                paymentMethodSelection: SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO,
            };
            delete dptPayload.company;
            delete dptPayload.successUrl;
            delete dptPayload.failedUrl;
            const resp = await dispatch(createDptOrderAction(dptPayload));
            setLoader(false);
            if (resp?.status) {
                const paymentId = getHostedPaymentIdFromResponse(resp);
                setHostedPaymentId(paymentId);
                hostedPaymentIdRef.current = paymentId;
                startHostedPaymentStatusPolling(resp);
                const hostedUrl = getHostedPaymentUrlFromResponse(resp);
                if (hostedUrl) {
                    preserveActivationSelectPaymentStep();
                    setHostedPaymentUrl(hostedUrl);
                    dispatch(setTripleaUrl(null, false));
                }
            } else {
                dispatch(
                    setFailedMessage(
                        resp?.data?.message
                            ? "Something wen't wrong"
                            : resp?.data
                                ? resp?.data
                                : "Something wen't wrong"
                    )
                );
            }
        } else {
            dispatch(
                setFailedMessage("Could not able to proceed, please contact administrator.")
            );
            setLoader(false);
        }
    };

    const handleProceedPayNow = async payload => {
        try {
            const checkoutAmount = getCheckoutAmount(payload);
            const payNowPayload = {
                quantity: payload?.quantity,
                currency: payNowCurrency,
                amount: checkoutAmount,
                companyId: payload?.company,
                subscriptionModuleType: payload?.subscriptionModuleType,
                paymentMethodSelection: SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW,
                planId: payload?.planId,
                baseRequestCurrency: payload?.baseRequestCurrency,
                baseAmountRate: getCheckoutBaseAmountRate(payload),
            };
            if (
                payNowPayload.subscriptionModuleType ===
                SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL
            ) {
                payNowPayload.capital = payload?.capital;
                payNowPayload.shares = payload?.shares;
                payNowPayload.baseRequestShareType = payload?.baseRequestShareType;
            }

            const resp = await dispatch(createPayNowOrderAction(payNowPayload));
            setLoader(false);
            if (resp?.status) {
                const paymentId = getHostedPaymentIdFromResponse(resp);
                setHostedPaymentId(paymentId);
                hostedPaymentIdRef.current = paymentId;
                startHostedPaymentStatusPolling(resp);
                const hostedUrl = getHostedPaymentUrlFromResponse(resp);
                if (hostedUrl) {
                    preserveActivationSelectPaymentStep();
                    setHostedPaymentUrl(hostedUrl);
                    dispatch(setTripleaUrl(null, false));
                }
            }
        } catch (error) {
            setLoader(false);
            dispatch(setFailedMessage("Something wen't wrong"));
        }
    };

    const addEmail = async (data) => {
        // ✅ clear old errors first
        clearErrors();

        const firstName = data?.firstName?.trim();
        const lastName = data?.lastName?.trim();
        const email = data?.email?.trim();
        const phone = data?.phone?.trim();
        const areaCode = data?.areaCode?.dial_code;
        const isTick = data?.isTick;

        const fields = [
            { key: "firstName", value: firstName, message: "Please enter your first name" },
            { key: "lastName", value: lastName, message: "Please enter your last name" },
            { key: "email", value: email, message: "Please enter your email address" },
            { key: "phone", value: phone, message: "Please enter your phone number" },
            { key: "areaCode", value: areaCode, message: "Please enter your area code" },
            { key: "isTick", value: isTick, message: "Please accept the terms and conditions" },
        ];

        let hasError = false;

        // ✅ Required field validation (all at once)
        fields.forEach(({ key, value, message }) => {
            if (!value) {
                setError(key, { type: "validate", message });
                hasError = true;
            }
        });

        // ✅ Email format validation (only if email exists)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        if (email && !emailRegex.test(email)) {
            setError("email", {
                type: "validate",
                message: "Please enter a valid email address",
            });
            hasError = true;
        }

        // ❗ Stop here if any error
        if (hasError) return;
        setAddUserDetailLoader(true)
        if (embedded && embeddedCompanyId) {
            try {
                dispatch(setTemporaryCompany(embeddedCompanyId));
                dispatch(setFailedMessage(null));
                await dispatch(getSingleSubscriptonPlan(embeddedCompanyId, planId));
                dispatch(setPaymentSteps(3));
            } catch (error) {
                dispatch(setFailedMessage("Something went wrong. Please try again."));
            } finally {
                setAddUserDetailLoader(false)
            }
            return;
        }
        // ✅ If all validations pass
        try {
            const payload = {
                first_name: firstName,
                last_name: lastName,
                email,
                // areaCode,
                // phone,
            };

            const resp = await dispatch(addPublicUserPaymentAction(payload));

            if (resp?.status) {
                dispatch(setTemporaryCompany(resp?.company?.id));
                dispatch(setPaymentSteps(3));
                dispatch(setFailedMessage(null));
                await dispatch(getSingleSubscriptonPlan(resp?.company?.id, planId));
                setAddUserDetailLoader(false)
            } else {
                dispatch(
                    setFailedMessage(
                        resp?.data || resp?.message || "Unable to save your details. Please try again."
                    )
                );
                setAddUserDetailLoader(false)
            }
        } catch (error) {
            dispatch(setFailedMessage("Something went wrong. Please try again."));
            setAddUserDetailLoader(false)
        }
    };

    // Submit (Step 3 “Complete”) — includes user details
    const onSubmit = async (data) => {
        const checkoutAmount = getCheckoutAmount(data);
        if (checkoutAmount > 0) {
            setLoader(true);
            let additionalPayload = {
                subscriptionModuleType: parseInt(stripeType),
                paymentMethodSelection: paymentMethodSelection,
                planId:
                    (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
                        ? stripePlans?._id
                        : stripePlans?.id) || null,
                baseRequestCurrency: stripePlans?.currency?.value || null,
                company: getActivationCompanyId(),
                quantity: selectedQuantity || GOLD_QUANTITY_LIST[0],
                currency: data?.currency || getValues("currency"),
                amount: checkoutAmount,
                baseAmountRate: getCheckoutBaseAmountRate(data),
                transactionFee: getCheckoutTransactionFee(data),
            };
            if (
                additionalPayload.subscriptionModuleType ===
                SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL
            ) {
                additionalPayload.capital = stripePlans?.capital?.id || null;
                additionalPayload.baseRequestShareType =
                    stripePlans?.capital?.shareType || null;
            }
            const payload = { ...data, ...additionalPayload };

            if (paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD) {
                await handleProceedCard();
            } else if (
                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
            ) {
                await dispatch(saveManualDetails(payload));
                await handleProceedCrypto(payload);
            } else if (
                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW
            ) {
                await dispatch(saveManualDetails(payload));
                await handleProceedPayNow(payload);
            } else {
                // bank transfer manual entry
                await dispatch(saveManualDetails(payload));
                try {
                    const resp = await dispatch(createManualEntryAction(payload, true));
                    const paymentId = getPaymentIdFromResponse(resp);
                    if (paymentId) {
                        setHostedPaymentId(paymentId);
                        hostedPaymentIdRef.current = paymentId;
                    }
                    await activateCompanyAfterPayment(resp);
                    if (resp?.status) {
                        setTimeout(() => setLoader(false), 1000);
                    } else {
                        setLoader(false);
                    }
                } catch (e) {
                    setLoader(false);
                }
            }
        } else {
            dispatch(setFailedMessage("Amount must be greater than 0"));
        }
    };

    // misc ui handlers
    const toggleTransactionVisibility = () => {
        setTransactionVisible((v) => !v);
    };

    const handleToggle = (value) => {
        setValue("saveInfo", value.target.checked);
        trigger("saveInfo");
    };

    const handleClickInfo = (type) => {
        setInfoModalStaticShow(true);
        setInfoModalStaticShowType(type);
    };

    const handleStep = (value) => {
        let stepValue = selectedStep - value;
        if (stepValue >= 1) {
            dispatch(setPaymentSteps(stepValue));
            dispatch(setOpenCartPage(false));
        }
        if (stepValue === 0) {
            if (embedded && onEmbeddedBack) {
                onEmbeddedBack();
                return;
            }
            navigate(RoutesPaths.HOME)
        }
    };

    const forwardPaymentPage = async (item) => {
        setAddCardLoader(true);
        try {
            if (
                item === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ||
                item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW
            ) {
                const selectedCurrency =
                    item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                        ? cryptoTransferCurrency
                        : item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW
                            ? payNowCurrency
                            : ["usd", "sgd"].includes(currencyWatch?.value)
                                ? currencyWatch
                                : defaultTransferCurrency;
                const checkoutAmount = getCheckoutAmount(getValues());
                const baseAmountRate = getCheckoutBaseAmountRate(getValues());
                const transactionFee = getCheckoutTransactionFee(getValues());

                setValue("currency", selectedCurrency);
                setValue("amount", checkoutAmount);
                setValue("baseAmountRate", baseAmountRate);
                setValue("transactionFee", transactionFee);
                setHostedPaymentUrl(null);
                setAutoStartHostedPayment(false);
                dispatch(setTripleaUrl(null, false));
                dispatch(setPaymentSteps(4));
                dispatch(selectedCardFunc(null));

                if (HOSTED_PAYMENT_METHODS.includes(item)) {
                    await onSubmit({
                        ...getValues(),
                        currency: selectedCurrency,
                        amount: checkoutAmount,
                        baseAmountRate,
                        transactionFee,
                    });
                }
            } else if (item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD) {
                await handleContinue()
                // await dispatch(subscriptionPlan(stripePlans));
                //     dispatch(setPaymentSteps(4));
            }
        } finally {
            setAddCardLoader(false);
        }
        dispatch(setOpenCartPage(false));
    };

    const paymentRef = useRef(null);

    const handleContinue = async () => {
        await paymentRef.current?.submitCard();
    };

    const handleHostedPaymentBack = () => {
        setHostedPaymentUrl(null);
        setAutoStartHostedPayment(false);
        hostedPaymentResolvedRef.current = false;
        dispatch(setTripleaUrl(null, false));
        dispatch(setPaymentSteps(3));
    };


    useEffect(() => {
        if (currencyWatch?.value) {
            dispatch(setCurrencyWatch(currencyWatch.value.toUpperCase()));
        }
    }, [currencyWatch, dispatch]);

    const isAdvisorUser = quotationDetail?.company?.isDefault

    const stepHeaderTitle = selectedStep === 1 ? 'Quotation details'
        : selectedStep === 2 ? "Add details"
            : selectedStep === 3 ? "Choose payment method"
                : selectedStep === 4 ? "Pay now"
                    : "Confirmation";

    const stepHeaderSubtitle = selectedStep === 1 ? 'Review the quotation details and attached documents. For any questions, click Contact us before continuing.'
        : selectedStep === 2 ? "These details will be used for billing and communication related to this quotation."
            : selectedStep === 3 ? "Currently available payment methods are shown below. More options will be enabled soon."
                : selectedStep === 4 ? "Review your payment details, select your preferred currency, and complete the payment using the selected card."
                    : isCompanySetupFlow
                        ? "Your payment has been successfully completed. You can review the transaction details below."
                        : "Your payment has been successfully completed. You can review the transaction details below or share the receipt for your records.";

    useEffect(() => {
        const root = document.documentElement;

        if (isAdvisorUser) {
            root.style.setProperty("--primary-color", "#494DA2");
            root.style.setProperty("--third-color", "rgba(73, 77, 162, 0.4)");
            root.style.setProperty("--linear-primary", "linear-gradient(90deg, #0d1b26 0%, #494DA2 100%)");
            root.style.setProperty("--low-opacity-primary", "rgba(73, 77, 162, 0.05)");
            root.style.setProperty('--step-card-background', 'rgba(73, 77, 162, 0.10)');
        } else {
            root.style.setProperty("--primary-color", "#2978b5");
            root.style.setProperty("--third-color", "#91bdde");
            root.style.setProperty("--linear-primary:", "linear-gradient(90deg, #0d1b26 0%, #30638c 100%)");
            root.style.setProperty("--low-opacity-primary", "rgba(41, 120, 181, 0.05)");
            root.style.setProperty('--step-card-background', 'rgba(41, 120, 181, 0.05)');
        }
    }, [isAdvisorUser]);
    return (
        <div className={embedded ? "bankTransferEmbedded" : "bankTransferPage"}>
            {!embedded && <PublicPageHeader />}
            {!embedded && selectedStep > 0 &&
                <PaymentSteps selectedStep={selectedStep} pageType={true} isAdvisor={isAdvisorUser} />
            }

            {/* <SubHeader /> */}
            <div className="container-fluid">
                {toastMessage && !embedded && <GetToaster />}
            </div>
            <div className={`${embedded ? "container-fluid px-0" : "container"} bankPage`}>
                {embedded && selectedStep > 0 && (
                    <div className="activate-substep-card activate-step-card">
                        <div>
                            <p><strong>Step 6.{selectedStep}</strong> {stepHeaderTitle}</p>
                            <span>{stepHeaderSubtitle}</span>
                        </div>
                    </div>
                )}
                {!embedded && selectedStep > 0 &&
                    <StepHeader step={selectedStep} isAdvisor={isAdvisorUser}
                        title={stepHeaderTitle}
                        subtitle={stepHeaderSubtitle}
                    />
                }
                <div className="row buyProductSection">
                    <div className="col-md-9 p-0">
                        <form>
                            {selectedStep === 0 &&
                                <PlanInvalid />
                                // <PaymentStatus planId={planId} />
                            }
                            {selectedStep === 1 && (
                                <PayoutDetail
                                    planId={planId}
                                    onContinue={() => dispatch(setPaymentSteps(2))}
                                    onBack={embedded ? () => handleStep(1) : undefined}
                                    isAdvisor={isAdvisorUser}
                                    skipFetch={embedded && !!embeddedQuotationDetail}
                                />
                            )}
                            {/* STEP 2: Your Details (replaces quantity step) */}
                            {selectedStep === 2 && (
                                <div className="container p-2">
                                    <div className="buyProductSectionBgPayout">
                                        <div className="">
                                            <div className="userDetail">
                                                <div className="innerDetail">
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <div className="inputHolder inputHolderColumn m-0">
                                                                <label className="label">First name*</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control bankTransferField"
                                                                    maxLength={60}
                                                                    {...register("firstName", { required: "Enter first name" })}
                                                                />
                                                            </div>
                                                            {errors.firstName && (
                                                                <span className="errorMessage">
                                                                    {errors.firstName.message}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <div className="inputHolder inputHolderColumn m-0">
                                                                <label className="label">Last name*</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control bankTransferField"
                                                                    maxLength={60}
                                                                    {...register("lastName", { required: "Enter last name" })}
                                                                />
                                                            </div>
                                                            {errors.lastName && (
                                                                <span className="errorMessage">
                                                                    {errors.lastName.message}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <div className="inputHolder inputHolderColumn m-0">
                                                                <label className="label">Email*</label>
                                                                <input
                                                                    type="email"
                                                                    className="form-control bankTransferField"
                                                                    maxLength={120}
                                                                    {...register("email", {
                                                                        required: "Enter email",
                                                                        pattern: {
                                                                            value:
                                                                                /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                                                            message: "Please enter a valid email address",
                                                                        },
                                                                    })}
                                                                />
                                                            </div>
                                                            {errors.email && (
                                                                <span className="errorMessage">
                                                                    {errors.email.message}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <div className="inputHolder inputHolderColumn m-0">
                                                                <label className="label">Phone number*</label>
                                                                <div className="areaCodeandnumberHolder">
                                                                    <Controller
                                                                        name="areaCode"
                                                                        control={control}
                                                                        rules={{ required: "Enter area code" }}
                                                                        render={({ field: { onChange, value } }) => (
                                                                            <Select
                                                                                theme={SELECT_BOX_THEME}
                                                                                styles={CUSTOM_SELECT_STYLES_AREA_CODE}
                                                                                className="select-border-area-code"
                                                                                options={country}
                                                                                getOptionLabel={(option) => option.dial_code}
                                                                                getOptionValue={(option) => option.dial_code}
                                                                                placeholder="Select"
                                                                                value={value}
                                                                                onChange={(option) => {
                                                                                    onChange(option);
                                                                                    clearErrors("areaCode");      // remove error instantly
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                    <input
                                                                        type="number"
                                                                        className="form-control bankTransferField"
                                                                        maxLength={120}
                                                                        {...register("phone", {
                                                                            required: "Enter phone number",
                                                                        })}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {errors.areaCode && (
                                                                <span className="errorMessage">
                                                                    {errors.areaCode.message}
                                                                </span>
                                                            )}
                                                            {errors.phone && (
                                                                <span className="errorMessage">
                                                                    {errors.phone.message}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="form-check form-check-info text-left emailCheck">
                                                            <input
                                                                id="flexCheck"
                                                                maxLength={50}
                                                                autoComplete="nope"
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                value=""
                                                                {...register("isTick", {
                                                                    required: 'Please accept the terms and conditions',
                                                                })}
                                                            />
                                                            <label className="emailConfirm" htmlFor="flexCheck">
                                                                I confirm that my email address is correct and I have read and accepted the <a href={terms} target="_blank" className="termsLink">terms and condition</a>.
                                                            </label>
                                                        </div>
                                                        {errors.isTick && (
                                                            <span className="errorMessage">
                                                                {errors.isTick.message}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="container p-0 pb-5">
                                        <div className="row">
                                            <div className="col-4">
                                                <div onClick={() => handleStep(1)} className="gobackButton">
                                                    <p className="m-0">Go back</p>
                                                </div>
                                            </div>

                                            <div className="col-8">
                                                <button
                                                    type="button"
                                                    disabled={addUserDetailLoader}
                                                    onClick={() => addEmail(getValues())}
                                                    className="gobackButton continueButton"
                                                >
                                                    {addUserDetailLoader && <i className="animateSpin fa-solid fa-circle-notch"></i>}
                                                    <p className="m-0">Continue</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* STEP 3: Select Payment Method */}
                            {selectedStep === 3 && (
                                <SelectPayment
                                    isAdvisor={isAdvisorUser} forwardPaymentPage={forwardPaymentPage} ref={paymentRef} setAddCardLoader={setAddCardLoader} />
                            )}

                            {/* STEP 4: Payment details (unchanged layout, now uses user details captured in Step 1) */}
                            {selectedStep === 4 && (
                                <div className="container p-2">
                                    <div className="buyProductSectionBgPayout">
                                        <div className="">
                                            <div className="userDetail">
                                                {hostedPaymentUrl && isHostedPaymentMethod ? (
                                                    <HostedPaymentRedirect url={hostedPaymentUrl} onBack={handleHostedPaymentBack} />
                                                ) : isHostedPaymentMethod && (autoStartHostedPayment || loader) ? (
                                                    <div className="hostedPaymentLoading">
                                                        <i className="animateSpin fa-solid fa-circle-notch"></i>
                                                        <span>Preparing secure checkout</span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD && (
                                                            <PayWithCard />
                                                        )}

                                                        {/* Totals */}
                                                        <div>
                                                            <div className="col-md-12">
                                                                <div className="transferInstructionHeader" onClick={toggleTransactionVisibility}                                >
                                                                    <div className="transferInstruction">
                                                                        <img src="assets/img/transferInfo.svg" alt="info" />
                                                                        <p className="m-0">Payment summary</p>
                                                                    </div>
                                                                    <div style={{ cursor: "pointer" }}>
                                                                        {isTransactionVisible ? (
                                                                            <img src="assets/img/arrowUp.svg" alt="Icon" />
                                                                        ) : (
                                                                            <img src="assets/img/arrowDown.svg" alt="Icon" />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className={`userDetailsTransaction userDetailsTransactionNew ${isTransactionVisible ? "" : "hidden"}`}>
                                                                    <PayoutDetailComponent step={2} isAdvisor={isAdvisorUser} />
                                                                </div>
                                                            </div>
                                                            <div className="followingSection">
                                                                {getValues('currency')?.value !== stripePlans?.currency?.value &&
                                                                    <div className="followingAmountAlign">
                                                                        <div>
                                                                            <p className="m-0 detailsAmountText">Gross total in base currency</p>
                                                                        </div>
                                                                        <div className="detailsAmountText detailsPriceText">
                                                                            {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ?
                                                                                stripePlans?.currency?.value : <Currency currency={stripePlans?.currency?.value || ''} />
                                                                            }{" "}
                                                                            <CurrencyFormat
                                                                                currency={stripePlans?.currency?.value}
                                                                                value={parseFloat(cartAmount?.price)}
                                                                                decimal={2}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {isBusinessPlanType ? (
                                                                    <>
                                                                        {businessPlanDisplayMode === BUSINESS_PLAN_DISPLAY_MODE.FEASIBILITY && (
                                                                            <>
                                                                                <div className="followingAmountAlign">
                                                                                    <p className="m-0 detailsAmountText">Full activation fee</p>
                                                                                    <div className="detailsAmountText detailsPriceText">
                                                                                        <Currency currency={businessPlanCurrency || "sgd"} />{" "}
                                                                                        <CurrencyFormat currency={businessPlanCurrency} value={parseFloat(businessPlanPriceConfig.activation || 0)} decimal={2} />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="followingAmountAlign">
                                                                                    <p className="m-0 detailsAmountText">Feasibility fee (15%)</p>
                                                                                    <div className="detailsAmountText detailsPriceText">
                                                                                        <Currency currency={businessPlanCurrency || "sgd"} />{" "}
                                                                                        <CurrencyFormat currency={businessPlanCurrency} value={parseFloat(businessPlanPriceConfig.feasibility || 0)} decimal={2} />
                                                                                    </div>
                                                                                </div>
                                                                                {hasBusinessPlanPlatformFee && (
                                                                                    <div className="followingAmountAlign">
                                                                                        <p className="m-0 detailsAmountText">Platform fee</p>
                                                                                        <div className="detailsAmountText detailsPriceText">
                                                                                            <Currency currency={businessPlanCurrency || "sgd"} />{" "}
                                                                                            <CurrencyFormat currency={businessPlanCurrency} value={parseFloat(businessPlanPlatformFee || 0)} decimal={2} />
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                                <div className="followingAmountAlign">
                                                                                    <p className="m-0 detailsAmountText">
                                                                                        Transaction fee {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ? `${cartAmount?.charges}%` : ""}
                                                                                    </p>
                                                                                    {shouldShowIncludedTransactionFee ? (
                                                                                        <div className="detailsAmountText">Included</div>
                                                                                    ) : (
                                                                                        <div className="detailsAmountText detailsPriceText">
                                                                                            <Currency currency={getValues("currency")?.value || businessPlanCurrency || "sgd"} />{" "}
                                                                                            <CurrencyFormat currency={getValues("currency") || businessPlanCurrency} value={parseFloat(getValues("transactionFee") || 0)} decimal={2} />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        )}

                                                                        {businessPlanDisplayMode === BUSINESS_PLAN_DISPLAY_MODE.FIXED && (
                                                                            <>
                                                                                <div className="followingAmountAlign">
                                                                                    <p className="m-0 detailsAmountText">Annual Fixed Fee</p>
                                                                                    <div className="detailsAmountText detailsPriceText">
                                                                                        <Currency currency={businessPlanCurrency || "sgd"} />{" "}
                                                                                        <CurrencyFormat currency={businessPlanCurrency} value={parseFloat(businessPlanPriceConfig.fixed || businessPlanFixedFee || 0)} decimal={2} />
                                                                                    </div>
                                                                                </div>
                                                                                <div className="followingAmountAlign">
                                                                                    <p className="m-0 detailsAmountText">Additional Transaction Fee</p>
                                                                                    <div className="detailsAmountText">Included</div>
                                                                                </div>
                                                                            </>
                                                                        )}

                                                                        {businessPlanDisplayMode === BUSINESS_PLAN_DISPLAY_MODE.QUOTATION && (
                                                                            <>
                                                                                <p className="m-0 detailsTotslAmountText">CUSTOM QUOTATION</p>
                                                                                <div className="followingAmountAlign">
                                                                                    <p className="m-0 detailsAmountText">Pricing</p>
                                                                                    <div className="detailsAmountText">Individually scoped</div>
                                                                                </div>
                                                                                <div className="followingAmountAlign">
                                                                                    <p className="m-0 detailsAmountText">Activation & Licensing</p>
                                                                                    <div className="detailsAmountText">Included in quotation</div>
                                                                                </div>
                                                                                <div className="followingAmountAlign">
                                                                                    <p className="m-0 detailsAmountText">Platform Access</p>
                                                                                    <div className="detailsAmountText">Included</div>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className="followingAmountAlign">
                                                                            <div>
                                                                                <p className="m-0 detailsAmountText">Gross total</p>
                                                                            </div>
                                                                            <div className="detailsAmountText detailsPriceText">
                                                                                {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ?
                                                                                    getValues('currency')?.value
                                                                                    : <Currency currency={getValues('currency')?.value || ''} />
                                                                                }{" "}
                                                                                <CurrencyFormat
                                                                                    currency={getValues('currency')}
                                                                                    value={
                                                                                        getValues('baseAmountRate')
                                                                                            ? parseFloat(getValues('baseAmountRate'))
                                                                                            : '0'
                                                                                    }
                                                                                    decimal={paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? 8 : 2}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="followingAmountAlign">
                                                                            <div className="followingicon detailsAmountText">
                                                                                {`Transaction fee ${cartAmount?.charges}%`}
                                                                                <div
                                                                                    onClick={() =>
                                                                                        handleClickInfo(
                                                                                            paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                                                                                ? I_POP_OVER.BANK_TRANSFER_SENDING_AMOUNT
                                                                                                : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                                                                                    ? I_POP_OVER.CRYPTO_TRANSFER_SENDING_AMOUNT
                                                                                                    : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                                                                                        ? I_POP_OVER.STRIPE_TRANSACTION_FEES
                                                                                                        : null
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <img
                                                                                        src="assets/img/InfoIcon.png"
                                                                                        className="infoIconImage"
                                                                                        alt="info"
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ||
                                                                                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW ||
                                                                                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ? (
                                                                                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ||
                                                                                    (stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.KILOGRAM &&
                                                                                        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER) ? (
                                                                                    <div className="detailsAmountText detailsPriceText">
                                                                                        {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                                                                            getValues("currency")?.value
                                                                                        ) : (
                                                                                            <Currency currency={getValues("currency")?.value || ""} />
                                                                                        )}{" "}
                                                                                        <CurrencyFormat
                                                                                            currency={getValues("currency")}
                                                                                            value={parseFloat(getValues("transactionFee") || 0)}
                                                                                            decimal={
                                                                                                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                                                                                    ? 8
                                                                                                    : 2
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="detailsAmountText">Included</div>
                                                                                )
                                                                            ) : (
                                                                                <div className="detailsAmountText detailsPriceText">
                                                                                    {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                                                                        getValues("currency")?.value
                                                                                    ) : (
                                                                                        <Currency currency={getValues("currency")?.value || ""} />
                                                                                    )}{" "}
                                                                                    <CurrencyFormat
                                                                                        currency={getValues("currency")}
                                                                                        value={parseFloat(getValues("transactionFee") || 0)}
                                                                                        decimal={
                                                                                            paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                                                                                ? 8
                                                                                                : 2
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </>
                                                                )}

                                                                <hr className="dootedHrLine" style={{ marginBottom: 8, marginTop: 0 }} />

                                                                {isBusinessPlanType ? (
                                                                    <>
                                                                        {businessPlanDisplayMode === BUSINESS_PLAN_DISPLAY_MODE.FEASIBILITY && (
                                                                            <div className="followingAmountAlign pb-0">
                                                                                <p className="m-0 detailsTotslAmountText">Amount due now</p>
                                                                                <div className="detailsTotslAmountText detailsPriceText">
                                                                                    <Currency currency={getBusinessPlanCheckoutCurrency()} />{" "}
                                                                                    <CurrencyFormat currency={getBusinessPlanCheckoutCurrency()} value={parseFloat(getBusinessPlanCheckoutAmount() || 0)} decimal={2} />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {businessPlanDisplayMode === BUSINESS_PLAN_DISPLAY_MODE.FIXED && (
                                                                            <div className="followingAmountAlign pb-0">
                                                                                <p className="m-0 detailsTotslAmountText">Annual total</p>
                                                                                <div className="detailsTotslAmountText detailsPriceText">
                                                                                    <Currency currency={businessPlanCurrency || "sgd"} />{" "}
                                                                                    <CurrencyFormat currency={businessPlanCurrency} value={parseFloat(businessPlanPriceConfig.fixed || businessPlanFixedFee || 0)} decimal={2} />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {businessPlanDisplayMode === BUSINESS_PLAN_DISPLAY_MODE.QUOTATION && (
                                                                            <div className="followingAmountAlign pb-0">
                                                                                <p className="m-0 detailsTotslAmountText">Next step</p>
                                                                                <div className="detailsTotslAmountText">Request a quotation</div>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <div className="followingAmountAlign pb-0">
                                                                        <div>
                                                                            <p className="m-0 detailsTotslAmountText">Net total</p>
                                                                        </div>
                                                                        <div className="detailsTotslAmountText detailsPriceText">
                                                                            {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                                                                getValues("currency")?.value
                                                                            ) : (
                                                                                <Currency currency={getValues("currency")?.value || ""} />
                                                                            )}{" "}
                                                                            <CurrencyFormat
                                                                                currency={getValues("currency")}
                                                                                value={parseFloat(getValues("amount") || 0)}
                                                                                decimal={
                                                                                    paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                                                                        ? 8
                                                                                        : 2
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="innerDetail">
                                                            <div className="row">
                                                                {!isTripleaUrl && (
                                                                    <div className="col-md-12 mb-3 mt-4">
                                                                        <div className="inputHolder inputHolderColumn m-0">
                                                                            <label className="label labelSelectCurrency">
                                                                                Select{" "}
                                                                                {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                                                                                    paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ||
                                                                                    paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW ||
                                                                                    paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                                                                    ? "currency"
                                                                                    : ""}
                                                                            </label>
                                                                            <Controller
                                                                                name="currency"
                                                                                rules={{ required: true }}
                                                                                control={control}
                                                                                render={({ field }) => (
                                                                                    <Select
                                                                                        theme={SELECT_BOX_THEME}
                                                                                        className="select-border bankTransferSelectField customBankTransferField"
                                                                                        {...field}
                                                                                        options={
                                                                                            paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW
                                                                                                ? [payNowCurrency]
                                                                                                : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                                                                                    ? [cryptoTransferCurrency]
                                                                                                    : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                                                                                        ? bankTransferCurrencies
                                                                                                        : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                                                                                            ? CURRENCY_NAME
                                                                                                            : []
                                                                                        }
                                                                                        getOptionLabel={(option) => (
                                                                                            <div className="selectLabelContent">
                                                                                                <img
                                                                                                    src={`assets/img/${option.value}.png`}
                                                                                                    alt={option.value}
                                                                                                    style={{ marginRight: 10, width: 20, height: 20 }}
                                                                                                />
                                                                                                {option.value.toUpperCase()}
                                                                                            </div>
                                                                                        )}
                                                                                        getOptionValue={(option) => option.value}
                                                                                        isClearable={false}
                                                                                        placeholder="Select currency"
                                                                                    />
                                                                                )}
                                                                            />
                                                                        </div>
                                                                        {errors.currency?.type === "required" && (
                                                                            <span className="errorMessage ">
                                                                                Select your{" "}
                                                                                {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                                                                                    paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW
                                                                                    ? "currency"
                                                                                    : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                                                                        ? "currency"
                                                                                        : ""}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                )}

                                                                {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER && (
                                                                    <>
                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="inputHolder inputHolderColumn m-0">
                                                                                <label className="label">Sending institution</label>
                                                                                <input
                                                                                    maxLength={50}
                                                                                    className="form-control bankTransferField"
                                                                                    placeholder="Enter the name of your bank or institution"
                                                                                    {...register("sendingInstruction", {
                                                                                        required: {
                                                                                            value: true,
                                                                                            message: "Sending Instruction is required",
                                                                                        },
                                                                                    })}
                                                                                />
                                                                            </div>
                                                                            {errors.sendingInstruction && (
                                                                                <span className="errorMessage">
                                                                                    {errors?.sendingInstruction?.message}
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="inputHolder inputHolderColumn m-0">
                                                                                <label className="label">Account number</label>
                                                                                <input
                                                                                    maxLength={50}
                                                                                    className="form-control bankTransferField"
                                                                                    placeholder="Enter your account number"
                                                                                    {...register("number", validationRules)}
                                                                                />
                                                                            </div>
                                                                            {errors?.number && (
                                                                                <span className="errorMessage">
                                                                                    {errors?.number?.message}
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                        <div className="col-md-12 mb-3">
                                                                            <div className="inputHolder inputHolderColumn m-0">
                                                                                <label className="label">Account holder name</label>
                                                                                <input
                                                                                    maxLength={40}
                                                                                    className="form-control bankTransferField"
                                                                                    placeholder="Enter the account holder name"
                                                                                    {...register("nickName", {
                                                                                        required: {
                                                                                            value: true,
                                                                                            message: "Account holder name is required",
                                                                                        },
                                                                                    })}
                                                                                />
                                                                            </div>
                                                                            {errors.nickName && (
                                                                                <span className="errorMessage">
                                                                                    {errors?.nickName?.message}
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                        <div className="col-md-6 mb-3">
                                                                            <div className="checkBoxSaveBank">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="customCheckbox"
                                                                                    checked={saveInfoWatch}
                                                                                    onChange={handleToggle}
                                                                                    id="saveInfoToggle"
                                                                                />
                                                                                <label htmlFor="saveInfoToggle" className="m-0">
                                                                                    Save bank info
                                                                                </label>
                                                                            </div>
                                                                        </div>

                                                                        <BankDetail
                                                                            toggleTransactionVisibility={toggleTransactionVisibility}
                                                                            isTransactionVisible={isTransactionVisible}
                                                                            bankTransferDetail={bankTransferDetail}
                                                                        />
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>

                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* STEP 5: Status */}
                            {selectedStep === 5 && <PaymentStatus planId={planId} paymentId={hostedPaymentId} isAdvisor={isAdvisorUser} isStep={true} isActivationFlow={isCompanySetupFlow} />}

                            {/* Footer Actions */}
                            {selectedStep > 0 &&
                                <>
                                    {selectedStep !== 5 && selectedStep !== 1 && selectedStep !== 2 && !isTripleaUrl && !hostedPaymentUrl && (
                                        <div className="container p-2">
                                            <div className="row mb-4">
                                                <div className="col-4">
                                                    <div onClick={() => handleStep(1)} className="gobackButton">
                                                        <p className="m-0">Go back</p>
                                                    </div>
                                                </div>

                                                {(selectedStep === 3 &&
                                                    paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD &&
                                                    selectedCard) ? (
                                                    <div className="col-8">
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                forwardPaymentPage(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD)
                                                            }
                                                            disabled={(selectedStep === 3 && !selectedCard) || addCardLoader}
                                                            className="gobackButton continueButton"
                                                        >
                                                            {addCardLoader && <i className="animateSpin fa-solid fa-circle-notch"></i>}
                                                            <p className="m-0">Continue</p>
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="col-8">
                                                        <button
                                                            type="button"
                                                            onClick={async () => {
                                                                if (selectedStep === 2) {
                                                                    // validate step-1 form first
                                                                    const ok = await trigger(["firstName", "lastName", "email"]);
                                                                    if (ok) {
                                                                        dispatch(setPaymentSteps(3));
                                                                        dispatch(selectedCardFunc(null));
                                                                    }
                                                                    return;
                                                                }
                                                                if (selectedStep === 4) {
                                                                    if (paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER) {
                                                                        const isBankTransferFormValid = await trigger([
                                                                            "currency",
                                                                            "sendingInstruction",
                                                                            "number",
                                                                            "nickName",
                                                                        ]);

                                                                        if (!isBankTransferFormValid) {
                                                                            return;
                                                                        }
                                                                    }
                                                                    onSubmit(getValues());
                                                                } else if (selectedStep === 3) {
                                                                    if (!paymentMethodSelection) {
                                                                        dispatch(setFailedMessage("Please select a payment method."));
                                                                        return;
                                                                    }
                                                                    forwardPaymentPage(paymentMethodSelection);
                                                                } else {
                                                                    dispatch(setPaymentSteps(3));
                                                                    dispatch(selectedCardFunc(null));
                                                                }
                                                            }}
                                                            disabled={
                                                                addCardLoader ||
                                                                (
                                                                    selectedStep === 4 &&
                                                                    (amountWatch <= 0 ||
                                                                        (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS &&
                                                                            cryptoAmountWatch < 100) ||
                                                                        loader)
                                                                )
                                                            }
                                                            className="gobackButton continueButton"
                                                        >
                                                            {(loader || addCardLoader) && <i className="animateSpin fa-solid fa-circle-notch"></i>}
                                                            <p className="m-0">
                                                                {selectedStep !== 4 ? (
                                                                    "Continue"
                                                                ) : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ? (
                                                                    <>
                                                                        Pay <Currency currency={getValues("currency")?.value || ""} />
                                                                        <CurrencyFormat
                                                                            currency={getValues("currency")}
                                                                            value={parseFloat(
                                                                                isBusinessPlanType && businessPlanDueNow
                                                                                    ? getBusinessPlanCheckoutAmount(getValues())
                                                                                    : getValues("amount") || 0
                                                                            )}
                                                                            decimal={
                                                                                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                                                                    ? 8
                                                                                    : 2
                                                                            }
                                                                        />
                                                                    </>
                                                                ) : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ||
                                                                    paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_PAYNOW ? (
                                                                    "Pay now"
                                                                ) : (
                                                                    "Complete"
                                                                )}
                                                            </p>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {/* {selectedStep === 5 && (
                                        <div className="container pb-5">
                                            <div className="row">
                                                <div className="col-md-12" style={{ textAlign: "center" }}>
                                                    <p className="m-0 pb-4">
                                                        Join kimbocorp to view campaign and download our app
                                                    </p>
                                                    <div className="appLinkSection p-0">
                                                        <img
                                                            src="/assets/img/Apple-download.svg"
                                                            alt=""
                                                            onClick={() =>
                                                                window.open(
                                                                    "https://apps.apple.com/us/app/kimbocorp/id6737228466",
                                                                    "_blank"
                                                                )
                                                            }
                                                        />
                                                        <img
                                                            src="/assets/img/Google-download.svg"
                                                            alt=""
                                                            onClick={() =>
                                                                window.open(
                                                                    "https://play.google.com/store/apps/details?id=io.kimbocorp",
                                                                    "_blank"
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )} */}
                                </>
                            }
                        </form>
                    </div>
                </div >
            </div >
            {!embedded && selectedStep !== 0 && selectedStep !== 5 && (
                <PublicPageFooter />
            )}
            <InfoModalStatic
                infoModalStaticShow={infoModalStaicShow}
                infoModalStaticClose={() => setInfoModalStaticShow(false)}
                infoModalStaicShowType={infoModalStaicShowType}
            />
        </div>
    );
}

export default function BankTransferPublic() {
    return <BankTransferPublicFlow />;
}
